import { buildRouteHead } from "@/lib/seo/routeHead";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/en/white-papers/")({
  head: () => buildRouteHead("/en/white-papers/", { noIndex: true }),
  beforeLoad: () => {
    throw redirect({ to: "/en/downloads", replace: true, statusCode: 301 });
  },
});
